<ng-container *notInProductCode="productCode.SGB">
  <div class="d-block d-lg-none">
    <fgb-page-header
      [pageTitle]="'wallet.page.title'"
      [backButtonLink]="'/'"
      [showQr]="false"
      [showFooter]="false"
    ></fgb-page-header>

    <div class="barcode-div">
      <fgb-barcode [isWalletPage]="true" [showFooter]="true" [showBarcode]="true"></fgb-barcode>
    </div>
  </div>

  <div #walletContainer class="wallet-container">
    <ng-container *ifScreenSize="screenType.Mobile">
      <div class="grab-point"><span class="minimize-icon"> </span></div>
    </ng-container>

    <!-- <fgbcl-campaigns-offers-list [showAllOffers]="false"></fgbcl-campaigns-offers-list> -->

    <ng-container *ngIf="walletItems$ | async as walletItems">
      <div class="wallet-redeem-carousel">
        <div class="container">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </div>
    </ng-container>

    <div class="container mt-4">
      <div class="history-container">
        <div class="history">
          <h5 class="title text-white">{{ 'redemption.history.title' | translate }}</h5>
          <p class="description text-white font-size-14 mb-0">{{ 'redemption.history.description' | translate }}</p>
        </div>
        <a class="font-size-14 claimed-text fw-bold text-center text-white" [routerLink]="['/rewards/claimed']">
          {{ 'rewards.wallet.view.claimed' | translate }}
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.SGB">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
